"use client";

import type { CartOutputDto, ShippingInfoInputDto } from "@sticker-giant/sg-frontend-common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CustomerFacingErrorMessages } from "@/constants/CustomerFacingErrorMessages";
import { CART_ACTIVE_FILTER } from "@/queries/useCart";
import { useGlobalStore } from "@/stores/useGlobalStore";
import { useServicesStore } from "@/stores/useServicesStore";

export const addGuestAddressMutationKey = ["addGuestAddress"] as const;

export function useAddGuestAddressMutation() {
  const cartClient = useServicesStore(state => state.cartClient);
  const cartId = useGlobalStore(state => state.cartId);
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: addGuestAddressMutationKey,
    mutationFn: async (shippingInfo: ShippingInfoInputDto): Promise<CartOutputDto> => {
      if (!cartClient) throw new Error("Cart client is not available.");
      if (!cartId) throw new Error("Cart id is not available.");
      return await cartClient.updateShippingInfo(
        cartId,
        shippingInfo,
        CustomerFacingErrorMessages.unableToAddNewShippingAddressToCart,
      );
    },
    onSuccess: cart => {
      queryClient.setQueriesData<CartOutputDto | null>(CART_ACTIVE_FILTER, cart);
    },
  });
}
